import { ref, ExtractPropTypes, SetupContext } from 'vue'
import { CUSTOM_FEEDBACK_PROPS } from './types'

type CustomFeedbackPropType = ExtractPropTypes<typeof CUSTOM_FEEDBACK_PROPS>

/**
 *
 * @param props
 * @param context
 */
export function setup(props: CustomFeedbackPropType, context: SetupContext) {
  const customFeedbackReason = ref('')
  const submitCustomFeedback = () => {
    context.emit('submitCustomFeedback', customFeedbackReason.value)
  }

  return {
    customFeedbackReason,
    submitCustomFeedback,
  }
}
